<greco-simple-dialog [data]="dialogData">
  <form [formGroup]="formGroup" style="display: flex; flex-direction: column; gap: 8px; padding: 8px">
    <greco-event-templates-input
      [communityId]="data.communityId"
      [required]="true"
      formControlName="eventTemplateDetails"
    ></greco-event-templates-input>
  </form>
</greco-simple-dialog>
